import { createResource } from 'react-resource-router';

import { assert, AssertionError } from '@atlassian/eoc-common';
import type { ResponderItemResponse } from '@atlassian/eoc-responder-names';

import { getTeam } from './endpoints';

export const getTeamResource = createResource<ResponderItemResponse | null>({
	type: 'getSyncTeamResource',
	getKey: (routerContext) => `getSyncTeamResource#${routerContext.match.params?.teamId}`,
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		assert(
			!!teamId,
			new AssertionError('getTeamResource', 'teamId should be set to fetch the team'),
		);

		const result = await getTeam(teamId);
		return result ?? null;
	},
	maxAge: 5 * 60 * 1000, // 5 mins
	isBrowserOnly: true,
});
